import SevaHistory from './SevaHistory';

export default SevaHistory;